<template>
  <div>
    <my-asidebar v-bind:active-tab="'settings'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">ForeCast </h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/settings'" class="text-white">Ayarlar</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dashboard-main-content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12" v-for="sail in sailList">
                <form id="portForm">
                  <div class="form-box">
                    <div class="form-content pb-2">
                      <h3 class="title mb-3"><a :href="basePath+'/sails/'+sail.id">#{{sail.id}}</a> - {{ sail.sailDate | ddMMyyyy}}  </h3>
                      <div class="row justify-content-between">
                        <div class="btn-box">
<!--                          <button :class="{'disabled' : false}" style="color: white" @click="invalidateCaches" class="theme-btn" type="button">Web cachelerini sıfırla</button>-->
                        </div>
                        <div class="input-box">
<!--                          <button :class="{'disabled' : false}" style="color: white" @click="saveChanges" class="theme-btn" type="button">Değişiklikleri Kaydet</button>-->
                        </div>
                      </div>
                      <div class="row justify-content">
                        <div class="input-box ml-2" v-for="room in sail.rooms">
                          <label class="form-control">{{ room.name }}</label>
                          <label class="form-control" style="text-align: center">{{ room.availableRoomCount }} / {{ room.totalRoomCount}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import PortDetail from "../component/port/PortDetail";
import MyAsidebar from "../component/common/MyAsidebar";
import TopBar from "../component/common/TopBar";
import messagePopupManager from "../util/messagePopupManager";

export default {
  name: "ForeCastPage",
  components: {TopBar, MyAsidebar,  PortDetail},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    projectName:{
      get(){
        return this.$store.getters.getProjectName;
      }
    },
    // roomList:{
    //   get(){
    //     return this.$store.getters.getRoomList;
    //   }
    // },
    sailList:{
      get(){
        return this.$store.getters.getSailsLite;
      },
      set(val){
        this.$store.commit("setSailsLite", val)
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_FORE_CAST"]) this.$router.push("/");

    // this.$store.dispatch("loadCruise").then(()=>{
    //   this.$store.dispatch("loadRoomList")
    // });
    this.$store.dispatch("loadSailList").then(response =>{
      this.sailList = response;
    });
  },
  methods: {

  }
}
</script>

<style scoped>

</style>